import React, { useRef, useEffect } from 'react';

interface ThumbnailBarProps {
    images: string[];
    currentIndex: number;
    onThumbnailClick: (index: number) => void;
}

const ThumbnailBar: React.FC<ThumbnailBarProps> = ({ images, currentIndex, onThumbnailClick }) => {
    // 1. Create a ref for the scrollable container
    const scrollerRef = useRef<HTMLDivElement>(null);

    // 2. Use useEffect to handle scrolling when currentIndex changes
    useEffect(() => {
        const scroller = scrollerRef.current;
        if (scroller) {
            // Get the element corresponding to the current index
            const selectedThumbnail = scroller.children[currentIndex] as HTMLElement;

            if (selectedThumbnail) {
                // Use scrollIntoView to bring the selected element into the center of the view
                selectedThumbnail.scrollIntoView({
                    behavior: 'smooth',
                    inline: 'center', // Centers the item horizontally
                    block: 'nearest', // Keeps it within the visible vertical space
                });
            }
        }
    }, [currentIndex]); // Depend on currentIndex

    return (
        <div className="thumbnail-bar-container">
            {/* 3. Attach the ref to the scrollable element */}
            <div className="thumbnail-bar-scroller" ref={scrollerRef}>
                {images.map((imageSrc, index) => (
                    <div
                        key={index}
                        className={`thumbnail-item ${index === currentIndex ? 'active' : ''}`}
                        onClick={() => onThumbnailClick(index)}
                    >
                        <img 
                            src={imageSrc} 
                            alt={`Page ${index + 1} thumbnail`} 
                            className="thumbnail-image"
                        />
                        <span className="thumbnail-index">{index + 1}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ThumbnailBar;